var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showFilter
        ? _c("Dash-filter", {
            attrs: {
              action: _vm.action,
              default: _vm.queryString,
              options: _vm.subscriptionFilterOptions,
              loadingList: _vm.loadingListSubscriptions,
            },
            on: { error: _vm.setError },
            model: {
              value: _vm.queryString,
              callback: function ($$v) {
                _vm.queryString = $$v
              },
              expression: "queryString",
            },
          })
        : _vm._e(),
      _c("subscriptions-table", {
        attrs: {
          "query-string": _vm.queryString,
          action: _vm.action,
          "has-locked": _vm.hasLocked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }